import React from 'react';
import { ReactComponent as IconInfo } from '../../../assets/img/icons/icon-catalog-info.svg'
import Translation from '../../global/Translation'
import styles from './style/mktools-outage-message.module.scss'

const MktoolsOutageMessage = () => {
    return (
        <div className={`${styles['mktools-outage-message-container']} container`}>
            <div className={styles.title}>
                <div>
                    <IconInfo />
                </div>
                <div>
                    <span>
                        <Translation
                            id="mktools_outage_notice_title"
                            defaultMessage="Important notice"
                        />
                    </span>
                </div>
            </div>
            <div className={styles.body}>
                <p>
                    <Translation
                        id="mktools_outage_notice_body"
                        defaultMessage="Dear user, please be advised that our website will be temporarily out of service until 02/27 due to a transition to a new logistics provider. During this period, should you require any assistance, please contact @Trade & Fulfillment Marketing CNA for support. We appreciate your understanding and apologize for any inconvenience this may cause."
                    />
                </p>
            </div>
        </div>
    );
};

export default MktoolsOutageMessage;